import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import ModalComponent from 'molecules/Modal';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteAccountAnalytics } from '../accountPageUtils';
import { ACCOUNT_SETTINGS } from '../Constants/Constants';
import CommunicationPreferencesCard from './CommunicationPreferencesCard';
import PersonalInfoCard from './PersonalInfoCard';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { PopUpView } from '../../MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { redirectToHomePage } from 'common/utilities/utils';

const DeleteAccountConfirmModal = ({ handleClose, deleteAccountCallback }) => {
  const { DELETE_ACCOUNT_TEXT, DELETE_ACCOUNT_MESSAGE, CANCEL, CONFIRM } = ACCOUNT_SETTINGS;

  return (
    <React.Fragment>
      <ModalComponent
        classNames='confirm-delete-account-modal'
        id='alertPop'
        role='dialog'
        show={true}
        closeDataTestId='handler-close'
        autoFocus={true}
        showCloseBtn={true}
        closeButtonHandler={handleClose}
        modalTitleRequired={false}
      >
        <div className='confirm-delete-account-content'>
          <p className='main-heading'>{translateWithI18Next(DELETE_ACCOUNT_TEXT)}</p>
          <p className='delete-account-text'>{translateWithI18Next(DELETE_ACCOUNT_MESSAGE)}</p>
          <div className='buttons-container'>
            <ButtonComp className='buttons-group cancel' onClickHandler={handleClose}>
              {translateWithI18Next(CANCEL)}
            </ButtonComp>
            <ButtonComp
              className='buttons-group save'
              onClickHandler={deleteAccountCallback}
              data-testid='delete-account-confirm'
            >
              {translateWithI18Next(CONFIRM)}
            </ButtonComp>
          </div>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};

const AccountSettings = ({ updateMenu, history }) => {
  const { ACCOUNT_SETTINGS_TEXT, DELETE_ACCOUNT_TEXT } = ACCOUNT_SETTINGS;
  const { SingleArrowback } = IMAGE_PATH;
  const [confirmDialog, setConfirmDialog] = useState(false);
  const profileReducer = useSelector(data => data.profileReducer || null);
  const tenantReducer = useSelector(data => data.tenantReducer);

  const deleteAccountCallback = () => {
    deleteAccountAnalytics(profileReducer?.customerId);
    AuthManager.getInstance().deleteAccount();
    setConfirmDialog(false);
    redirectToHomePage({ history });
  };

  return (
    <div className='account-settings-container'>
      <div className='account-settings-header-mobile'>
        <img
          className='backArrow-account-setting'
          onClick={() => updateMenu('')}
          src={SingleArrowback}
          alt='Back Arrow'
        />
        <span className='account-setting-text-header'>{translateWithI18Next(ACCOUNT_SETTINGS_TEXT)}</span>
      </div>
      <p className='account-setting-text-heading'>{translateWithI18Next(ACCOUNT_SETTINGS_TEXT)}</p>
      <PersonalInfoCard basicData={profileReducer?.basic} isLoading={profileReducer?.isLoading} />
      <CommunicationPreferencesCard
        tenantId={tenantReducer?.tenantId}
        communicationPreferences={profileReducer?.marketingPreferences}
        basicData={profileReducer?.basic}
      />
      <ButtonComp
        data-testid='delete-button-testid'
        className='delete-account-button'
        onClickHandler={() => {
          setConfirmDialog(true);
          PopUpView({ popupTitle: translateWithI18Next(DELETE_ACCOUNT_TEXT) });
        }}
      >
        {translateWithI18Next(DELETE_ACCOUNT_TEXT)}
      </ButtonComp>
      {confirmDialog && (
        <DeleteAccountConfirmModal
          handleClose={() => {
            setConfirmDialog(false);
          }}
          deleteAccountCallback={deleteAccountCallback}
        />
      )}
    </div>
  );
};

export default AccountSettings;
